/**
 * useInviteIQCapture — captures ?iq= and ?iq_surface= from URL on mount and stores them.
 * Should be called once at the app root level.
 *
 * P0-2 FIX: Also captures ?iq_surface= for cross-domain attribution persistence.
 * When a user navigates from katalag.com to kloutforce.com or koordinator.com,
 * the outbound link appends ?iq= and ?iq_surface= so the destination app can
 * re-hydrate attribution into its own localStorage before auth.
 */
import { useEffect } from 'react';
import { setPendingInviteIQ, setSurfaceKatalogId } from './storage';

export function useInviteIQCapture(): void {
  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);

      // Capture explicit invite code
      const iqCode = params.get('iq');
      if (iqCode) {
        setPendingInviteIQ(iqCode);
      }

      // P0-2: Capture cross-domain surface katalog ID
      const surfaceId = params.get('iq_surface');
      if (surfaceId) {
        setSurfaceKatalogId(surfaceId);
      }
    } catch {
      // URL parsing failed
    }
  }, []);
}
